import { render, staticRenderFns } from "./expertForm.vue?vue&type=template&id=873c1edc&scoped=true"
import script from "./expertForm.vue?vue&type=script&lang=js"
export * from "./expertForm.vue?vue&type=script&lang=js"
import style0 from "./expertForm.vue?vue&type=style&index=0&id=873c1edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873c1edc",
  null
  
)

export default component.exports